module.exports = __webpack_public_path__ + "static/media/li.bbd23e06.png";